<div class="container-fluid" >
  <!-- start page title -->
  <div class="row">
    <div class="col-12">
      <div class="page-title-box">
        <div class="page-title-right">
          <a class="btn btn-primary" (click)="volver()">
            Volver
          </a>
        </div>
        <h3 class="page-title">Plan de Evaluación |
          <span style="color: #016E97;">{{nombre_oferta}}</span> - <span style="color: #016E97;">{{uc_pre_impreso}}</span>
        </h3>
      </div>
    </div>
  </div>
  <div class="row" style="overflow-x: scroll;" [formGroup]="formularioPlanEvaluacion" id="formularioPlanEvaluacion">
    <div class="col-12">
        <div class="card" style="border-color: white;">
          <div class="card-body" style="margin-bottom: 150px;">
            <!-- Invoice Logo -->
            <div class="row">
              <div class="col-md-12">
                <h5>Total porcentaje : {{total}}% de 100% </h5>
              </div>
            </div>
            <hr class="text-dark">
            <div class="row">
              <div class="col-12">
                <table class="table">
                  <thead>
                    <tr class="table-primary">
                      <th scope="col">N°</th>
                      <th class="text-center">Logro</th>
                      <th class="text-center">Fecha</th>
                      <th class="text-center">Porcentaje</th>
                    </tr>
                  </thead>
                  <tbody formArrayName="plan_evaluacion">
                    <ng-content *ngFor="let r of resultado; let i = index">
                      <tr [formGroupName]="i">
                        <th scope="row">{{i+1}}</th>
                        <td class="text-center">{{r.nombre}}</td>
                        <td class="text-center">
                          <div class="input-group">
                            <input class="form-control" placeholder="Fecha" id="fecha" formControlName="fecha" [readOnly]="true" #fch="ngbDatepicker" ngbDatepicker>
                            <button class="btn btn-outline-secondary bi bi-calendar3 calendar" (click)="fch.toggle()" type="button"></button>
                          </div>
                        </td>
                        <td>
                          <div class="form-check form-switch">
                            <input
                            type="text"
                            class="form-control"
                            id="porcentaje-{{i}}"
                            name="porcentaje-{{i}}"
                            placeholder="porcentaje"
                            mask="99"
                            formControlName="porcentaje_evaluacion"
                            [value]="r.porcentaje"
                            (input)="calcula(i, $event.target)"
                            >
                          </div>
                        </td>
                      </tr>
                    </ng-content>
                  </tbody>
                </table>
              </div>
            </div>
            <div class="row mt-3">
              <div class="col-12 text-center">
                <button type="button" class="btn btn-lg btn-primary" (click)="confirmacion()">Aceptar</button>
              </div>
            </div>
          </div> <!-- end card-body-->
      </div> <!-- end card -->
    </div> <!-- end col-->
  </div>
</div>
<app-modal [titulo]="titulo" [tipo_color]="tipo_color" [letra_color]="letra_color" [mensaje]="mensaje" (saveModal)="guardar_todo()"></app-modal>
